const TOKEN_KEY = 'engraving-admin-token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function parseResponse(response) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.message || 'Ошибка запроса');
  }

  return payload;
}

export async function fetchContent() {
  return parseResponse(await fetch('/api/content'));
}

export async function loginAdmin({ username, password }) {
  return parseResponse(
    await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    })
  );
}

export async function fetchAdminContent(token) {
  return parseResponse(
    await fetch('/api/admin/content', {
      headers: { Authorization: `Bearer ${token}` }
    })
  );
}

export async function saveAdminContent(token, content) {
  return parseResponse(
    await fetch('/api/admin/content', {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(content)
    })
  );
}

export async function uploadImage(token, file) {
  const formData = new FormData();
  formData.append('image', file);

  return parseResponse(
    await fetch('/api/admin/uploads', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    })
  );
}

